module.exports = "/assets/8f3c71082bf6143a1c56c3c4070ba460.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/menu/car.png
// module id = 3550
// module chunks = 0